<template>
  <v-card>
    <v-card-title class="white py-5 px-8 grey--text text--darken-2" style="border-bottom: 1px solid #eee !important">
      <v-icon class="ml-3">mdi-chart-areaspline</v-icon>
      أكثر الصفحات مشاهدة
      <v-spacer />
      <v-btn
        icon
        large
        text
        class="mx-2"
        title="تصدير لإكسيل"
        color="green darken-2"
        @click="SET_FILTERS({ type: 'pages' }); SHOW_EXPORT_DIALOG()"
      >
        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="py-7">
      <v-container>
        <v-data-table
          item-key="id"
          class="elevation-0 grey lighten-5"
          :loading="loading"
          :headers="headers"
          :items="data.rows"
          loading-text="جاري تحميل البيانات"
          no-data-text="لا يوجد بيانات"
          disable-filtering
          disable-pagination
          disable-sort
          hide-default-footer
        >
          <template v-slot:item.pagePath="{ item }">
            <div class="text-left">
              <a
                dir="ltr"
                target="_blank"
                class="blue--text"
                :href="websiteUrl + item.pagePath"
              >{{ item.pagePath }}</a>
            </div>
          </template>
        </v-data-table>
      </v-container>
    </v-card-text>
  </v-card>
</template>


<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'pages-table',
  props: ['data', 'loading'],

  data: function () {
    return {
      headers: [
        {
          value: 'pagePath',
          text: 'الرابط'
        },
        {
          value: 'pageviews',
          text: 'المشاهدات'
        },
        {
          value: 'avgSessionDuration',
          text: 'متوسط وقت الجلسة'
        },
        {
          value: 'bounceRate',
          text: 'معدل التردد'
        },
        {
          value: 'sessions',
          text: 'الجلسات'
        },
        {
          value: 'users',
          text: 'الزوار'
        }
      ],

      websiteUrl: process.env.VUE_APP_WEBSITE_BASE_URL
    }
  },


  methods: {
    ...mapMutations(
      'statistics', ['SHOW_EXPORT_DIALOG', 'SET_FILTERS']
    )
  }
}
</script>
